import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import actionAttendance from '~/modules/master/redux/actions/attendance'

const useAttendance = () => {
  const data = useSelector((state) => get(state, 'master.attendance'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(actionAttendance, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useAttendance
